<template lang="pug">
el-dialog(:visible.sync='inner_visible', :title='title', :before-close='before_close')
  slot
  div(slot='footer')
    slot(name='footer')
      .ui.button(@click='cancel()') 取消
</template>

<script>
export default {
  name: 'promise-dialog',
  props: {
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      inner_visible: false,
      canceled: false,
    }
  },
  watch: {
    visible() {
      this.inner_visible = this.visible
    },
    inner_visible() {
      if (this.inner_visible !== this.visible)
        this.$emit('update:visible', this.inner_visible)
    },
  },
  methods: {
    invoke_and_show(command) {
      return this.show(this.invoke(command))
    },
    show(promise) {
      this.inner_visible = true
      this.canceled = false
      return promise
        .then(response => {
          this.inner_visible = false
          if (!this.canceled)
            return response
        })
        .catch(error_message => {
          this.inner_visible = false
          if (!this.canceled)
            throw (error_message)
        })
    },
    invoke(command) {
      return new Promise((resolve, reject) => {
        this.$native.invoke(command, (response) => {
          if (response && response.text === '$success')
            resolve(response)
          else {
            const error_message = ((response || {}).text || '').replace('$error', '').trim()
            reject(error_message)
          }
        })
      })
    },
    cancel() {
      this.canceled = true
      this.inner_visible = false
    },
    before_close(done) {
      this.cancel()
      done()
    },
  },
}
</script>



// WEBPACK FOOTER //
// PromiseDialog.vue?79da1037